<template>
    <gradient-background>
      <center-card>
        <template v-slot:card-title>
          {{$t('register.title')}}
        </template>
        <template v-slot:card-body>
          <register-form/>
        </template>
      </center-card>
    </gradient-background>
</template>

<script>
  import GradientBackground from '../layouts/general/GradientBackground.vue';
  import CenterCard from '../layouts/cards/CenterCard.vue';
  import RegisterForm from '../components/auth/RegisterForm.vue';

  export default {
    components: {
      GradientBackground,
      CenterCard,
      RegisterForm,
    },
  };
</script>
